// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Jrvj1","recommendMassage":"styles_recommendMassage__FYcgv","redirectBtn":"styles_redirectBtn__Lel0b"};